import { useValidateContentQuery } from 'modules/campaigns/lib/hooks/useValidateContentQuery';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { Nullable } from 'utils/tsHelpers';
import { useExperimentsTranslations } from './useTranslations';

const source = 'useTemplateValidationPerLocale';

export const useTemplateValidationPerLocale = () => {
  const dispatch = useDispatch();
  const { t } = useExperimentsTranslations();
  const { refetch: fetchTemplateValidation } = useValidateContentQuery({
    fetchPolicy: 'no-cache',
    skip: true,
  });

  return async (
    templateId: number,
    templateName: string,
    messageTypeId: number,
    localeName: Nullable<string>,
  ) => {
    try {
      const { data, error: hasError } = await fetchTemplateValidation({
        templateId,
        messageTypeId,
        locale: localeName
          ? {
              name: localeName,
            }
          : null,
      });

      return !hasError ? data?.validateContent?.errors || [] : null;
    } catch (e) {
      const resource = templateName.length ? templateName : templateId;
      dispatch(
        addNegativeToastWithErrorId(t('errorMessage.templateValidation', { resource }), source, e),
      );
    }
    return null;
  };
};
